<script lang="ts" setup>
  import type { ButtonHTMLAttributes } from 'vue'

  type Props = {
    disabled?: boolean
    buttonType?: ButtonHTMLAttributes['type']
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'button-click' | 'link-click'): void
  }>()

  function onButtonClick() {
    emit('button-click')
  }

  function onLinkClick() {
    emit('link-click')
  }
</script>

<template>
  <div class="c-button-and-link">
    <Button
      type="secondary"
      class="button"
      :button-type="props.buttonType ?? 'button'"
      :disabled="props.disabled"
      @click="onButtonClick()"
    >
      <!-- @slot Button text content -->
      <slot name="button" />
    </Button>
    <div class="caption">
      <!-- @slot Caption text content -->
      <slot name="caption" />
    </div>
    <div
      class="link-underline"
      @click.prevent="onLinkClick()"
    >
      <!-- @slot Link text content -->
      <slot name="link" />
    </div>
  </div>
</template>

<style scoped>
.c-button-and-link {
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 3em;

  .c-button {
    width: 100%;
    align-items: center;
    color: white;
    font-family: Bariol, sans-serif;
    font-size: 1.25rem;
    font-weight: 600;
    letter-spacing: 1.68px;
    text-transform: uppercase;
  }

  .caption {
    margin-top: 1.25em;
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 0.875em;
    opacity: 0.6;
    text-align: center;
  }

  .link-underline {
    margin-top: 1em;
    margin-bottom: 1em;
    color: var(--color-secondary);
    cursor: pointer;
    font-family: Open-Sans, sans-serif;
    font-size: 1.125em;
    text-align: center;
    text-decoration: underline;
    text-transform: uppercase;
  }
}
</style>
